import { render, staticRenderFns } from "./AddSEOptimization.vue?vue&type=template&id=079dd016&scoped=true"
import script from "./AddSEOptimization.vue?vue&type=script&lang=js"
export * from "./AddSEOptimization.vue?vue&type=script&lang=js"
import style0 from "./AddSEOptimization.vue?vue&type=style&index=0&id=079dd016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dd016",
  null
  
)

export default component.exports